(function (app, core) {
    const COOKIE_VALID_DAYS = 30;

    /**
     * Sidebar Language Switcher
     *
     * @tutorial sidebar-language
     * @param {HTMLElement} element Main container element of the language switcher
     * @class
     */
    app.SidebarLanguage = function (element) {
        const _self = this;

        _self.container = element;
        _self.langItems = _self.container.querySelectorAll('.js-lang');

        _self.setListeners();
    };

    /**
     * Sets language items click listeners for cookies
     */
    app.SidebarLanguage.prototype.setListeners = function () {
        const _self = this;

        _self.langItems.forEach((item) => {
            item.addEventListener('click', () => {
                const lang = item.dataset.langShort
                    ? item.dataset.langShort
                    : '';
                _self.setLanguage(lang);
            });
        });
    };

    /**
     * Saves key/value to Local Storage using `core.localStorage.setStorage`
     *
     * @param {string} cookieName cookie name identifier
     * @param {string} lang lang identifier
     */
    app.SidebarLanguage.prototype.setLocalStorage = function (
        cookieName,
        lang
    ) {
        core.localStorage.setStorage(cookieName, lang, COOKIE_VALID_DAYS, true);
    };

    /**
     * Sets cookie and reload page
     *
     * @param {string} lang 2 character string representing language
     */
    app.SidebarLanguage.prototype.setLanguage = function setLanguage(lang) {
        const _self = this;

        _self.setLocalStorage('req_language', lang);
        _self.setLocalStorage('req_languageReload', 'true');

        // set moment locale
        moment.locale(lang);
    };

    let widgets = document.querySelectorAll('[data-widget="sidebar-language"]');
    Array.prototype.forEach.call(widgets, function (widget) {
        new app.SidebarLanguage(widget);
    });
})(PULSE.app, PULSE.core);
